/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { createContext } from 'react';
import { IL10N } from '../../Common/l10n-keys';

export const FspTileContext = createContext({
    l10n: {} as IL10N,
    cdnUrl: '',
    focusFirstTileInNewPage:() => {},
});

export default function FspTileContextProvider(
    props: React.PropsWithChildren<{l10n: IL10N, cdnUrl: string}>) {
    function focusFirstTileInNewPage() {

    }

    const ctxValue = {
        l10n: props.l10n,
        cdnUrl: props.cdnUrl,
        focusFirstTileInNewPage: focusFirstTileInNewPage,
    };

    return (
        <FspTileContext.Provider value={ctxValue}>
            {props.children}
        </FspTileContext.Provider>
    );
}
